import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-161bd03c")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_q_btn = _resolveComponent("q-btn")

  return (_openBlock(), _createBlock(_component_q_btn, {
    label: _ctx.button.text,
    loading: _ctx.isLoading,
    class: "button h-radius",
    color: "primary",
    "text-color": "white",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickOnButton()))
  }, null, 8, ["label", "loading"]))
})